import mixpanel from 'mixpanel-browser'
import { useFeatureFlags } from '@/composables/env/useFeatureFlags'
import { config } from '@/config'

let initialized = false

export function useMixpanel() {
  const { isSandbox, isLocalDev } = useFeatureFlags()
  const isEnabled = (isSandbox || isLocalDev) && !!config.mixpanelToken

  function init() {
    if (!isEnabled || initialized) return
    mixpanel.init(config.mixpanelToken, {
      autocapture: true,
      track_pageview: true,
      record_sessions_percent: 100,
      api_host: 'https://api-eu.mixpanel.com',
      record_mask_text_selector: '[data-mp-no-track]',
    })
    initialized = true
  }

  // Use that instead
  function identify(userId: string, properties?: Record<string, unknown>) {
    if (!isEnabled || !initialized) return
    mixpanel.identify(userId)
    if (properties) {
      mixpanel.people.set(properties)
    }
  }

  function track(event: string, properties?: Record<string, unknown>) {
    if (!isEnabled || !initialized) return
    mixpanel.track(event, properties)
  }

  function reset() {
    if (!isEnabled || !initialized) return
    mixpanel.reset()
  }

  return { init, identify, track, reset, isEnabled }
}
